import React from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import Heading from "@tds/core-heading";
import FlexGrid from "@tds/core-flex-grid";
import Text from "@tds/core-text";
import Box from "@tds/core-box";
import StaticPig from "../images/static-pig.jpeg";

// 404/403 component.
function NotFound({ t, content, children }) {
  return (
    <FlexGrid>
      <FlexGrid.Row>
        <FlexGrid.Col>
          <Box vertical={5} between={3} xs={12} md={6}>
            <Heading level="h1">{t("whoops")}</Heading>
            {content !== null && <Text size="large">{content}</Text>}
            {children}
          </Box>
        </FlexGrid.Col>
        <FlexGrid.Col horizontalAlign="center" xs={12} md={6}>
          <Box vertical={3}>
            <img
              style={{ maxWidth: 180 }}
              alt={t("flyingPig")}
              src={StaticPig}
            />
          </Box>
        </FlexGrid.Col>
      </FlexGrid.Row>
    </FlexGrid>
  );
}

NotFound.propTypes = {
  t: PropTypes.func.isRequired,
  content: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

NotFound.defaultProps = {
  content: null,
  children: null,
};

export default withTranslation()(NotFound);
